import Axios from 'axios';

const baseURL = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8080';

export const axiosInstance = Axios.create({
	baseURL,
	validateStatus: (_) => true,
	headers: {
		'Content-Type': 'application/json',
	},
});
